<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a>
  <span class="m-r-4">/ </span>
  <a class="m-r-4" routerLink="/master-data/repair-part">Repair Code Part Association</a>
  <span>/ {{ isEditMode() ? 'Edit' : 'Add New' }}</span>
</div>

<div class="m-b-12" style="display: flex; align-items: center; gap: 12px">
  <h3>{{ isEditMode() ? 'Edit' : 'Add New' }}</h3>
  @if (isEditMode()) {
    <div style="display: flex; flex-grow: 1; justify-content: end; gap: 8px">
      <mc-button
        fit="small"
        variant="outlined"
        icon="arrow-anti-clockwise-clock"
        (click)="onAuditLogClick()"
        (keydown.enter)="onAuditLogClick()"
        (keydown.space)="$event.preventDefault(); onAuditLogClick()">
        Audit log
      </mc-button>
    </div>
  }
</div>

@if (isEditMode() && repairPartData()) {
  <div class="mds-text--body-normal mds-neutral--weak__text-color m-b-12">
    Last updated on {{ repairPartData()?.updatedAt | date: "d MMM yyyy 'at' HH:mm:ss" }} by {{ repairPartData()?.updatedBy || 'User' }}
  </div>
}

<form [formGroup]="createRepairPartForm">
  @if (formSubmitErrors().length > 0) {
    <div class="error m-b-8">
      <mc-icon class="error-icon" icon="exclamation-octagon" size="20"></mc-icon>
      <div class="title">Errors</div>
      <ul>
        @for (error of formSubmitErrors(); track $index) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
  <div class="flex-column">
    @if (formSubmitErrors().length === 0) {
      <app-error [formContainer]="createRepairPartForm"></app-error>
    }
  </div>

  <div class="pure-g">
    <div class="pure-u-1 pure-u-md-3-3 pure-u-lg-3-3 p-r-8">
      <div class="aems-card m-b-16">
        <app-repair-part-information [formGroup]="createRepairPartForm" [isEditMode]="isEditMode()"> </app-repair-part-information>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="m-t-16" style="display: flex; align-items: center; width: 100%">
      @if (isEditMode()) {
        <mc-button
          type="button"
          variant="outlined"
          appearance="neutral"
          fit="small"
          icon="trash"
          (click)="onDeleteAssociation()"
          (keydown.enter)="onDeleteAssociation()"
          (keydown.space)="$event.preventDefault(); onDeleteAssociation()">
          Delete Association
        </mc-button>
      }
      <div style="display: flex; flex: 1; justify-content: flex-end; gap: 8px">
        <mc-button
          type="button"
          variant="outlined"
          appearance="neutral"
          fit="small"
          (click)="onCancel()"
          (keydown.enter)="onCancel()"
          (keydown.space)="$event.preventDefault(); onCancel()">
          Cancel
        </mc-button>
        <mc-button
          type="button"
          variant="filled"
          appearance="primary"
          fit="small"
          [disabled]="
            isEditMode()
              ? !createRepairPartForm.dirty || createRepairPartForm.invalid || submitLoader()
              : createRepairPartForm.invalid || submitLoader()
          "
          [loading]="submitLoader()"
          (click)="onSubmit()"
          (keydown.enter)="onSubmit()"
          (keydown.space)="$event.preventDefault(); onSubmit()">
          {{ isEditMode() ? 'Save changes' : 'Add association' }}
        </mc-button>
      </div>
    </div>
  </div>
</form>

<!-- Cancel Confirmation Modal -->
@if (showCancelDialog()) {
  <mc-modal heading="Unsaved Changes" fit="small" dimension="small" [open]="showCancelDialog()" (closed)="keepEditing()">
    <p>Are you sure you want to cancel? All unsaved changes will be lost permanently.</p>
    <mc-button
      slot="secondaryAction"
      dialogaction="cancel"
      appearance="neutral"
      variant="filled"
      (click)="keepEditing()"
      (keydown.enter)="keepEditing()"
      (keydown.space)="$event.preventDefault(); keepEditing()">
      Keep Changes
    </mc-button>
    <mc-button
      slot="primaryAction"
      appearance="primary"
      variant="filled"
      (click)="confirmCancel()"
      (keydown.enter)="confirmCancel()"
      (keydown.space)="$event.preventDefault(); confirmCancel()">
      Discard changes
    </mc-button>
  </mc-modal>
}

<!-- Delete Confirmation Modal -->
@if (showDeleteDialog()) {
  <mc-modal heading="Delete Association" fit="small" dimension="small" [open]="showDeleteDialog()" (closed)="cancelDeleteAssociation()">
    <p>Removing the association will prevent users from using {{ partCode }} with repair code {{ repairCode }}.</p>
    <mc-button
      slot="secondaryAction"
      appearance="neutral"
      variant="outlined"
      (click)="cancelDeleteAssociation()"
      (keydown.enter)="cancelDeleteAssociation()"
      (keydown.space)="$event.preventDefault(); cancelDeleteAssociation()">
      Cancel
    </mc-button>
    <mc-button
      slot="primaryAction"
      appearance="primary"
      [loading]="deleteLoader()"
      (click)="confirmDeleteAssociation()"
      (keydown.enter)="confirmDeleteAssociation()"
      (keydown.space)="$event.preventDefault(); confirmDeleteAssociation()">
      Delete
    </mc-button>
  </mc-modal>
}

<!-- Audit Log Modal -->
<mc-modal
  backdropcloseactiondisabled
  heading="Audit Log"
  fit="small"
  dimension="large"
  [open]="openAuditLog"
  (closed)="openAuditLog = false">
  @if (openAuditLog) {
    <app-master-data-audit-log [transactionCode]="repairCode + '/' + partCode" label="Repair Part" [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
